// extracted by mini-css-extract-plugin
export var container = "_53-1";
export var cornerButtonContainer = "_53-5";
export var disabled = "_53-2";
export var fileContainer = "_53-4";
export var hiddenInput = "_53-3";
export var widthContainer = "_53-0";